import { render } from "./fisHeader.vue?vue&type=template&id=32906376&scoped=true&ts=true"
import script from "./fisHeader.vue?vue&type=script&lang=ts"
export * from "./fisHeader.vue?vue&type=script&lang=ts"

import "./fisHeader.vue?vue&type=style&index=0&id=32906376&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32906376"]])

export default __exports__